import { getBaseUrl, getCSRFTokenValue } from "./helper";

jQuery(function ($) {
  if ($("#contactForm").length > 0) {
    $("#contactForm").submit(async function (event) {
      event.preventDefault();

      // console.log("submitting...");

      $('#form-error').hide();
      $('#form-mask').fadeIn();

      const data = {
        name: $(this).find("input[name=fName]").val(),
        email: $(this).find("input[name=fEmail]").val(),
        organisation: $(this).find("input[name=fOrganisation]").val(),
        message: $(this).find("textarea[name=fMessage]").val(),
      };

      const csrfToken = await getCSRFTokenValue(); // Await the promise

      // console.log(csrfToken);

      $.ajax({
        type: "POST",
        url: `${getBaseUrl()}api/form/contactus/submit`,
        headers: {
          "X-CSRF-Token": csrfToken,
        },
        data: JSON.stringify(data),
        contentType: "application/json",
        success: function (response) {
          console.log("Success");
          $('#thankyou').show();
          $('#form-elements').hide();
          $('#form-mask').fadeOut();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log("Error");
          console.log(jqXHR, textStatus, errorThrown);
          $('#form-error').show();
          $('#form-mask').fadeOut();
        },
      });
    });
  }
});
